import React from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import PropTypes from 'prop-types';

import LinkBase from '@glowforge/gf-styled/src/components/link/link-base';

const CookieNavigationItem = ({ href, text }) => {
  const { query } = useRouter();
  const currentCountry = query['country-code'] ?? '';

  return (
    <Link href={`${href}/${currentCountry}`} passHref legacyBehavior>
      <LinkBase variant='nav'>{text}</LinkBase>
    </Link>
  );
};

CookieNavigationItem.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default CookieNavigationItem;
